const useBloqueioEvento = ({ user, evento, anuidadePedido }) => {
    // Usuário não logado NÃO é bloqueio
    if (!user?.id) return null;

    // Bloqueio por anuidade
    if ((anuidadePedido && anuidadePedido.status !== 1) || !anuidadePedido) {
        return {
            tipo: 'ANUIDADE_PENDENTE',
            mensagem: user.name + ", a sua anuidade está pendente, clique no botão a seguir e regularize a mesma para poder participar dos eventos da FETRON.",
            permitirAcao: true
        };
    }

    // Futuro:
    // if (evento?.encerrado) { ... }
    // if (evento?.vagas === 0) { ... }

    return null;
};

export default useBloqueioEvento;